import React from "react";
import { Trans } from "react-i18next";

export default function SignInPage() {
  return (
    <div>
      <h2>
        <Trans ns="common">Sign In</Trans>
      </h2>
    </div>
  );
}
